if (!customElements.get("lsg-mega-menu")) {
  customElements.define("lsg-mega-menu", class LSGMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        toggle: ".js-lsg-mega-menu-sub-toggle",
        column: ".js-lsg-mega-menu-column",
        filterToggle: ".js-lsg-mega-menu-filters",
        quickBuy: ".js-lsg-mega-menu-card-quick-buy"
      };
      this.body = document.querySelector('body');
      this.toggle = this.querySelectorAll(this.selectors.toggle);
      this.quickBuy = this.querySelectorAll(this.selectors.quickBuy);
      this.filterToggle = this.querySelectorAll(this.selectors.filterToggle);
      this.init();
    }

    showSubMenu(element, item, isClick) {
      let isOpen = true;
      if (isClick && item.classList.contains('is-active')) {
        isOpen = false;
      }
      this.querySelectorAll(`${this.selectors.column}.is-active`).forEach(activeEl => {
        activeEl.classList.remove('is-active');
      });
      this.querySelectorAll(`${this.selectors.toggle}.is-active`).forEach(activeEl => {
        activeEl.classList.remove('is-active')
      });
      if (isOpen) {
        if (element != null) {
          element.classList.add('is-active');
        }
        item.classList.add('is-active');
      }
    }

    applyFilter(item) {
      item.classList.toggle('is-active');
      const parent = item.closest(`.lsg-mega-menu__product-listing`);
      if (parent != null) {
        const filters = parent.querySelectorAll(`${this.selectors.filterToggle}.is-active`);
        const els = parent.querySelectorAll('.lsg-mega-menu__product-listing__item');
        const listing = [parent];
        if (filters.length > 0) {
          els.forEach(el => {
            el.classList.add('is-hidden');
          });
          filters.forEach(filter => {
            const val = filter.getAttribute('data-value');
            els.forEach(el => {
              const valEl = el.getAttribute('data-value').split(',');
              if (valEl.includes(val)) {
                el.classList.remove('is-hidden');
              }
            });
          });
          listing.forEach(el => {
            if (el.querySelector(".lsg-mega-menu-card:not(.is-hidden)") == null) {
              el.classList.add('is-hidden');
            } else {
              el.classList.remove('is-hidden');
            }
          });
        } else {
          els.forEach(el => {
            el.classList.remove('is-hidden');
          });
          listing.forEach(el => {
            el.classList.remove('is-hidden');
          });
        }
      }
    }

    initMegaMenu() {
      this.toggle.forEach(item => {
        const element = this.querySelector('.js-lsg-mega-menu-column[data-value="' + item.getAttribute('data-value') + '"]');
        if (element != null) {

          item.addEventListener('mouseover', (e) => {

            const x = window.matchMedia("(min-width: 991px)");
            if (x.matches) {
              e.preventDefault();
              this.showSubMenu(element, item, false);
            }
          })
          if(item.closest('.lsg-mega-menu--mob')!= null) {
            item.addEventListener('click', (e) => {
              e.preventDefault();
              this.showSubMenu(element, item, true);
            })
          }
        }
      });
      this.filterToggle.forEach(item => {
        item.addEventListener('click', e => {
          this.applyFilter(item)
        });
      });
    }

    initQuickBuy() {
      this.quickBuy.forEach(el => {
        el.addEventListener('click', (event) => {
          event.preventDefault();
          const href = el.getAttribute('href');
          if (href.includes('/products/')) {
            let slug = href.split('/products/')[1];
            if (slug.includes('/')) {
              slug = slug.split('/')[0];
            }
            document.dispatchEvent(new CustomEvent('show-quick-buy', {
              detail: {slug: slug},
            }))
          }
        })
      })
    }

    init() {
      this.initMegaMenu();
      this.initQuickBuy();
    }
  });
}
